export let legal = {
	init: function( block ){
		console.log("legal init", block);
		const $legalBlocks = block.querySelectorAll(".shopify-policy__container");
		const backBtn = `<button class="js-back"><span>→</span></button>`;
		$legalBlocks.forEach( ($legal, index) => {
			let $backBlock = $legal.querySelector(".c-ttl_page .c-btn_back");
			console.log($legal, $backBlock);
			if( $backBlock ){
				$back = $backBlock.querySelector("button");
				if( !$back ){
					$backBlock.innerHTML = backBtn;
				}
			}
		});
	},
	checkContactAfterSend: function(){
		console.log("contact check");
		let params 		= location.search.substring(1);
		let paramArry	= params.split("&");
		let hasParam = false;
		for (let i = 0; paramArry[i]; i++) {
			let kv = paramArry[i].split("=");
			if( kv[0] === "contact_posted" ){
				hasParam = true;
			}
		}
		//console.log(hasParam, paramArry);
		if( hasParam ){
			setTimeout(function(){
				window.scrollTo(0, 0);
			}, 100);
		}else{
			contact.init();
		}
		//?contact_posted=true#ContactForm
	}
}
let contact = {
	arry: [],
	targets: [],
	init: function(){
		contact.targets = document.querySelectorAll(".contact__fields dl");
		
		contact.nav();
	},
	nav: function(){
		contact.targets.forEach( ($dl) => {
			let $input = $dl.querySelector("input");
			if( $input ){
				$input.removeEventListener("change", contact.check, false);
				$input.addEventListener("change", contact.check, false);
			}else{
				let $textarea = $dl.querySelector("textarea");
				if( $textarea ){
					$textarea.removeEventListener("change", contact.check, false);
					$textarea.addEventListener("change", contact.check, false);
				}
			}
		});
	},
	check: function(){
		let arry = [0, 0, 0];
		contact.targets.forEach( ($dl, index) => {
			let $input = $dl.querySelector("input");
			let val = "";
			if( $input ){
				val = $input.value;
				let type = $input.type;
				if( type === "text" ){
					if( val != "" ){
						arry[index] = 1;
					}
				}else if( type === "email" ){
					let value = val.trim();
					if( val != "" ){
						const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
						if (!emailRegex.test(value)) {
							$dl.classList.add('is-emailvalid_error');
						}else{
							if( $dl.classList.contains('is-emailvalid_error') ){
								$dl.classList.remove('is-emailvalid_error');
							}
							arry[index] = 1;
						}
					}
				}
			}else{
				let $textarea = $dl.querySelector("textarea");
				if( $textarea ){
					val = $textarea.value;
					if( val != "" ){
						arry[index] = 1;
					}
				}
			}
		});
		let hasEmpty = arry.includes(0);
		let $send = document.querySelector(".contact_page_contact .contact__button button");
		if( hasEmpty ){
			$send.disabled = true;
		}else{
			$send.disabled = false;
		}
		console.log(arry, hasEmpty);
	}
}